const GRID_SIZE = 8;
export const lineHeightToNumber = (height, size) => height / (size * GRID_SIZE);